import type { Component } from 'vue';
import ContentJobslist from './ContentJobslist.vue';
import ContentVideo from './ContentVideo.vue';
import ContentAccordion from '~/components/modules/ContentAccordion.vue';
import ContentClinic3d from '~/components/modules/ContentClinic3d.vue';
import ContentDownloadList from '~/components/modules/ContentDownloadList.vue';
import ContentFAQ from '~/components/modules/ContentFAQ.vue';
import ContentIntro3d from '~/components/modules/ContentIntro3d.vue';
import ContentMedia from '~/components/modules/ContentMedia.vue';
import ContentStackedCards from '~/components/modules/ContentStackedCards.vue';
import ContentText from '~/components/modules/ContentText.vue';
import ContentValues from '~/components/modules/ContentValues.vue';
import TeaserBig from '~/components/modules/TeaserBig.vue';

export const ModuleComponents: Record<string, Component> = {
  ContentAccordionRecord: ContentAccordion,
  ContentClinic3dRecord: ContentClinic3d,
  ContentDownloadlistRecord: ContentDownloadList,
  ContentFaqRecord: ContentFAQ,
  ContentIntro3dRecord: ContentIntro3d,
  ContentJobslistRecord: ContentJobslist,
  ContentMediumRecord: ContentMedia,
  ContentStackedcardRecord: ContentStackedCards,
  ContentTextRecord: ContentText,
  ContentValueRecord: ContentValues,
  TeaserBigRecord: TeaserBig,
  ContentVideoRecord: ContentVideo,
};
